import styled from 'styled-components';

export const ContentWrapper = styled.div`
    margin: 0 16px 36px 16px;
`;
